import { gql } from "@apollo/client";

export const CREATE_STUDENT_RENT_MATERIAL = gql`
  mutation CreateRentMaterial($input: RentMaterialInput) {
    createRentMaterial(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_STUDENT_RENT_MATERIAL = gql`
  mutation UpdateRentMaterial($id: ID!, $input: RentMaterialInput) {
    updateRentMaterial(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_RENT_STATUS = gql`
  mutation UpdateRentMaterialStatus($id: ID!, $input: RentMaterialInput) {
    updateRentMaterialStatus(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_STUDENT_RENT_MATERIAL = gql`
  mutation DeleteRentMaterial($id: ID!) {
    deleteRentMaterial(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_RETURN_RENT_MATERIAL = gql`
  mutation UpdateReturnRentMaterial($id: ID!, $input: ReturnRentMaterialInput) {
    updateReturnRentMaterial(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_STUDENT_RETURN_RENT_MATERIAL = gql`
  mutation CreateReturnRentMaterial(
    $input: ReturnRentMaterialInput
    $inputRentMaterial: RentMaterialInput
  ) {
    createReturnRentMaterial(
      input: $input
      inputRentMaterial: $inputRentMaterial
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_RENT_MATERIAL_PAGINATION = gql`
  query GetRentMaterialPagination(
    $page: Int
    $limit: Int
    $from: Date
    $to: Date
    $pagination: Boolean
    $returnStauses: [RENT_MATERIAL_RETURN_STATUS]
    $studentId: ID
    $academicYearId: ID
  ) {
    getRentMaterialPagination(
      page: $page
      limit: $limit
      from: $from
      to: $to
      pagination: $pagination
      returnStauses: $returnStauses
      studentId: $studentId
      academicYearId: $academicYearId
    ) {
      data {
        _id
        desc
        rentBy
        returnStatus
        academicYearId {
          _id
          academicYear
          academicYearInKhmer
        }
        studentId {
          _id
          englishName
          firstName
          lastName
          profileImg
        }
        createdBy {
          mainUserId {
            firstName
            lastName
            latinName
          }
        }
        updatedBy {
          mainUserId {
            firstName
            lastName
            latinName
          }
        }
        createdAt
        dateTime
        rentMaterialItems {
          _id
          condition
          dueDate
          listMaterialUnitId {
            _id
            imageSrc
            materialId {
              _id
              materialEnName
              materialKhName
            }
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
          qty
          warehouseId {
            _id
            warehouseName
          }
          returnRentMaterialItems {
            _id
            condition
            desc
            qty
            warehouseId {
              _id
              warehouseName
            }
            returnRentMaterialId {
              _id
              returnDate
              returnBy
              receiveBy {
                _id
              }
            }
          }
        }
        returnRentMaterials {
          _id
          returnBy
          returnDate
          desc
          receiveBy {
            mainUserId {
              latinName
            }
          }
          returnRentMaterialItems {
            _id
            condition
            desc
            qty
            warehouseId {
              _id
              warehouseName
            }
            rentMaterialItemId {
              _id
              listMaterialUnitId {
                _id
                unitId {
                  _id
                  unitEnName
                  unitKhName
                }
                materialId {
                  _id
                  materialKhName
                }
              }
            }
          }
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
